export enum ErrorCode {

    //Role
    ROLE_VALIDATION_ROLENAMECANNOTBEEMPTY = 7001,
    ROLE_VALIDATION_ROLENAMESMALLERTHANMIN = 7002,
    ROLE_VALIDATION_ROLENAMEBIGGERTHANMAX = 7003,
    ROLE_VALIDATION_ROLENAMESPECIALCHARACTERRESTRICT = 7004,
    ROLE_VALIDATION_ROLENAMEINVALIDDUETOSTARTINGWITHNUMBER = 7005,

    ROLE_VALIDATION_ROLEDESCRIPTIONCANNOTBEEMPTY = 7006,
    ROLE_VALIDATION_ROLEDESCRIPTIONSMALLERTHANMIN = 7007,
    ROLE_VALIDATION_ROLEDESCRIPTIONBIGGERTHANMAX = 7008,
    ROLE_VALIDATION_ROLEDESCRIPTIONINVALID = 7009,

    ROLE_VALIDATION_ROLEONEFEATURESETSELECTIONREQUIRED = 7010,
    ROLE_VALIDATION_ROLECANNOTEDITSTANDARDROLEORNOCEIDSET = 7011,
    ROLE_VALIDATION_ROLEDUPLICATENAME = 7012,
    ROLE_VALIDATION_EXCEEDSMAXIMUMROLELIMITINCOMPANY = 7013,
    ROLE_VALIDATION_ROLEEXISTSWITHSAMEFEATURESETS = 7014,
    ROLE_VALIDATION_ROLECANNOTBERETURNEDFORHIDDENGROUPCOMPANY = 7015,
    ROLE_VALIDATION_ROLESCORECANNOTBEZERO = 7016,
    ROLE_VALIDATION_INVALIDROLEID = 7017,
    ROLE_VALIDATION_STANDARDROLESCANNOTBEDELETED = 7018,
    ROLE_VALIDATION_ROLEDELETEACTIONSARENOTSPECIFIED = 7019,
    ROLE_VALIDATION_ROLEDELETEACTIONSARENOTMATCHINGWITHDB = 7020,

    //Group
    GROUP_VALIDATION_GROUPNAMECANNOTBEEMPTY = 7101,
    GROUP_VALIDATION_GROUPNAMESMALLERTHANMIN = 7102,
    GROUP_VALIDATION_GROUPNAMEBIGGERTHANMAX = 7103,
    GROUP_VALIDATION_GROUPNAMESPECIALCHARACTERRESTRICT = 7104,
    GROUP_VALIDATION_GROUPNAMEINVALIDDUETOSTARTINGWITHNUMBER = 7105,

    GROUP_VALIDATION_GROUPDESCRIPTIONCANNOTBEEMPTY = 7106,
    GROUP_VALIDATION_GROUPDESCRIPTIONSMALLERTHANMIN = 7107,
    GROUP_VALIDATION_GROUPDESCRIPTIONBIGGERTHANMAX = 7108,
    GROUP_VALIDATION_GROUPDESCRIPTIONSPECIALCHARACTERRESTRICT = 7109,

    GROUP_VALIDATION_GROUPONEROLESELECTIONREQUIRED = 7110,
    GROUP_VALIDATION_GROUPINVALIDCOMPANYSELECTION = 7110,
    GROUP_VALIDATION_CANNOTCREATEEDITDEFAULTGROUP = 7111,
    GROUP_VALIDATION_GROUPDUPLICATENAME = 7112,
    GROUP_VALIDATION_GROUPEXCEEDSMAXIMUMLIMITINCOMPANY = 7113,
    GROUP_VALIDATION_DEFAULTGROUPCANNOTBEDELETED = 7116,
    GROUP_VALIDATION_SINGLEACTIVEGROUPCANNOTBEDELETED = 7117,
    GROUP_VALIDATION_USERSASSOCIATEDNEWGROUPFORUSERMIGRATIONNOTPROVIDED = 7118,
    GROUP_VALIDATION_HIDDENGROUPENABLEDFORCOMPANY = 7119,

    //User
    USER_VALIDATION_EMAILIDCANNOTBEEMPTY = 7201,
    USER_VALIDATION_INVALIDEMAILIDENTERED = 7202,
    USER_VALIDATION_USERALREADYEXISTSINCOMPANY = 7203,
    USER_VALIDATION_GROUPNOTASSIGNED = 7204,
    USER_VALIDATION_USERNOTASSOCIATEDWITHCOMPANY = 7205,
    USER_VALIDATION_USERALREADYEXISTSINANOTHERCOMPANY = 7206,
    USER_VALIDATION_INVALIDBUSINESSCONTACT = 7207,
    USER_VALIDATION_USERDOESNOTBELONGTOANYCOMPANY = 7208,
    USER_VALIDATION_BUIDNOTASSIGNED = 7209,
    USER_VALIDATION_FIRSTNAMECANNOTBEEMPTY = 7210,
    USER_VALIDATION_LASTNAMECANNOTBEEMPTY = 7211,
    USER_VALIDATION_INVALIDFIRSTNAME = 7212,
    USER_VALIDATION_INVALIDLASTNAME = 7213,
    USER_VALIDATION_USERALREADYACTIVE = 7214,
    USER_VALIDATION_USERPROFILENOTACTIVE = 7215,
    USER_VALIDATION_USERNAMEEMAILEMPTYSTRING = 7216,
    USER_VALIDATION_USERPROFILENOTSETUPORINACTIVE = 7217,
    USER_VALIDATION_USERALREADYEXISTS = 7218,
    USER_VALIDATION_USERINPERSONATIONCOMMENTSCANNOTBEEMPTY = 7219,
    USER_VALIDATION_USERIMPERSONATIONEDLOGINIDCANNOTBEEMPTY = 7220,
    USER_VALIDATION_USERIMPERSONATIONREQUESTERLOGINIDCANNOTBEEMPTY = 7221,
    USER_VALIDATION_USERIMPERSONATIONENCRYPTEDPASSWORDCANNOTBENULL = 7222,
    USER_VALIDATION_INAVALIDPARAMUSERIMPERSONATION = 7223,


    //User Setup

    USERSETUP_VALIDATION_USERISALREADYACTIVEORDOESNOTEXIST = 7301,
    USERSETUP_VALIDATION_INVALIDACTIVATIONMAIL = 7302,
    USERSETUP_VALIDATION_ACTIVATIONMAILEXPIRED = 7303,
    USERSETUP_VALIDATION_UNIQUEIDENTIFIERSDOESNOTMATCH = 7304,
    USERSETUP_VALIDATION_USERNAMEALREADYINUSE = 7305,
    USERSETUP_VALIDATION_UNIQUEIDENTIFIERCANNOTBEEMPTY = 7306,
    USERSETUP_VALIDATION_PASSWORDCANNOTBEEMTPTY = 7307,
    USERSETUP_VALIDATION_BOTHSECURITYQUESTIONSHAVETOBEANSWERED = 7308,
    USERSETUP_VALIDATION_SAMESECURITYQUESTIONSSELECTED = 7309,
    USERSETUP_VALIDATION_PASSWORDISNOTSTRONG = 7310,
    USERSETUP_VALIDATION_USERNAMENOTMATCHINGNECESSARYFORMAT = 7311,
    USERSETUP_VALIDATION_USERPROFILEALREADYCREATED = 7312,
    USERSETUP_VALIDATION_INVALIDUSERINFORMATION = 7313,
    USERSETUP_VALIDATION_NEWPASSWORDSHOULDNOTMATCHNEWPASSWORD = 7314,


    //Login/Profile
    LOGIN_VALIDATION_LOGINDOESNOTEXIST = 7401,
    LOGIN_VALIDATION_USERISNOTACTIVE = 7402,
    LOGIN_VALIDATION_EULANOTACCEPTED = 7403,
    LOGIN_VALIDATION_EXCESSIVELOGINATTEMPTS = 7404,
    LOGIN_VALIDATION_FAILEDLOGIN = 7405,
    LOGIN_VALIDATION_USERALREADYLOCKED = 7406,
    LOGIN_VALIDATION_LOGINLOCKCOOLINGCOMPLETED = 7407,
    LOGIN_VALIDATION_FAILEDLOGINBUTCANBERETRIED = 7408,
    LOGIN_VALIDATION_OLDANDNEWPASSWORDCANNOTBESAME = 7409,
    LOGIN_VALIDATION_PASSWORDABOUTTOEXPIREIN30DAYS = 7410,
    LOGIN_VALIDATION_PASSWORDABOUTTOEXPIREIN10DAYS = 7411,
    LOGIN_VALIDATION_PASSWORDEXPIRED = 7412,
    LOGIN_VALIDATION_IMPERSONATIONREQUESTORISNOTHONEYWELLUSER = 7417,
    //Common Errors
    VALIDATION_UNAUTHORIZEDERROR = 7501,
    VALIDATION_ERRORINPROCESSING = 7502

}